'use es6';

import Raven from 'Raven';
import { logError } from './loggers';

const getSentryExtra = error => ({
  level: typeof error === 'string' ? 'error' : 'warning',
  fingerprint: ['laboratory-lib', 'lab:error'],
  tags: {
    'laboratory-lib:error': 'error'
  }
});

export function createErrorObject(caller, error) {
  const errorObject = new Error(`[laboratory-lib "${caller}"] ${error}`); // We set a custom Error name to tell this comes from Laboratory

  errorObject.name = 'LaboratoryError'; // The Error stack is irrelevant as the Error doesn't originate from here

  delete errorObject.stack;
  return errorObject;
}
export function logAndReportError(error, options = {}) {
  // First logs the error in the console and then attempts to report it to Sentry
  // Which still could fail and if it does, we log the failure exception
  logError(error);

  try {
    const captureMethod = typeof error === 'string' ? 'captureMessage' : 'captureException';
    Raven[captureMethod](error, Object.assign({}, getSentryExtra(error), {}, options));
  } catch (failureError) {
    logError(failureError);
  }
}